import React, { FC } from "react";

import { TextGroupProps } from "../../types";

export const TextGroup: FC<TextGroupProps> = ({ label, text }) => {
  return (
    <div className="ams-expanded-row__block">
      <div className="ams-expanded-row__label">{label}:</div>
      <div className="ams-expanded-row__text">{text}</div>
    </div>
  );
};
